import type { Feature } from './types';

import { urlValidator } from 'toolkit/components/forms/validators/url';

import { getEnvValue } from '../utils';

const title = 'Network switcher';

const config: Feature<{ mainnetUrl: string; testnetUrl: string | undefined }> = (() => {
  const mainnetUrl = getEnvValue('NEXT_PUBLIC_NETWORK_SWITCHER_MAINNET_URL');
  const testnetUrl = getEnvValue('NEXT_PUBLIC_NETWORK_SWITCHER_TESTNET_URL');

  // Mainnet is this deployment's own address and is required for the switcher to
  // show at all. Testnet URL is optional - when unset, the Testnet option is simply
  // omitted from the menu (see NetworkSwitcher.tsx) rather than shown disabled, so
  // the switcher only ever offers destinations that actually work today. Setting
  // NEXT_PUBLIC_NETWORK_SWITCHER_TESTNET_URL later is all that's needed to add it.
  if (mainnetUrl && urlValidator(mainnetUrl) === true && (!testnetUrl || urlValidator(testnetUrl) === true)) {
    return Object.freeze({
      title,
      isEnabled: true,
      mainnetUrl,
      testnetUrl: testnetUrl || undefined,
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
